import { useQuery } from '@tanstack/react-query';
import { fetchRemitSettings } from '../api/remit-settings.ts';
import { RemitSetting } from '../models/remit-setting.ts';

export default function useRemitSettings(id: string) {
  return useQuery<RemitSetting[]>({
    queryKey: ['remitSettings', id],
    queryFn: () => fetchRemitSettings(id),
  });
}
